import { render, staticRenderFns } from "./ConceptsSearch.vue?vue&type=template&id=6710a94a&scoped=true"
import script from "./ConceptsSearch.vue?vue&type=script&lang=js"
export * from "./ConceptsSearch.vue?vue&type=script&lang=js"
import style0 from "./ConceptsSearch.vue?vue&type=style&index=0&id=6710a94a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710a94a",
  null
  
)

export default component.exports